import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
//Modulos locales
import {BuscarTutorialByDenominacion} from './functions/funcionesArboles';
import {MenuModulos} from 'lib.front';

/**
 *
 * @param {Array} capacitaciones
 * @param {Function} onOpenLista
 * @param {Array} arrTutoriales
 * @param {Function} onIndex
 * @returns un COmponente con la lista de todas las capacitaciones (distribuidas en un arbol)
 * se controla el indice y tambien en que posicion se encuentra el tutorial a ser seleccionado
 */
export const ListaTutorial = ({capacitaciones, onOpenLista, arrTutoriales, onIndex}) => {
   const [denominacionFiltro, setDenominacionFiltro] = useState({value: null, input: ''});

   useEffect(() => {
      if (denominacionFiltro.input !== '') {
         if (capacitaciones) {
            let arr = BuscarTutorialByDenominacion(capacitaciones, denominacionFiltro.input);
            let index = -1;
            if (arr && arr.length > 0) {
               index = arrTutoriales.findIndex(item => item.codigo === arr[0].codigo);
            }

            if (index !== -1) {
               onIndex(index);
            }
         }
      }
   }, [denominacionFiltro]);

   function handleOnClickItem(e) {
      //Buscar id en Arr
      let index = arrTutoriales.findIndex(item => item.codigo === e.codigo);
      onIndex(index);
   }

   //Un Handle busca un codigo determinado
   const handleTutorialSearchValue = (e, newValue) => {
      if (newValue) {
         setDenominacionFiltro({value: null, input: newValue.denominacion});
      }
   };

   //handle para el input de BucadorArboles
   const handleTutorialSearchInput = (e, newValue) => {
      setDenominacionFiltro({...denominacionFiltro, input: newValue});
      onOpenLista(false);
   };

   return (
      <>
         {capacitaciones !== null && (
            <MenuModulos
               buscadorProps={{
                  valorIgnorar: '',
                  soloHojas: true,
                  value: denominacionFiltro.value,
                  onChange: handleTutorialSearchValue,
                  inputValue: denominacionFiltro.input,
                  onInputChange: handleTutorialSearchInput,
                  clearOnBlur: true,
                  clearOnEscape: true,
                  selectOnFocus: true
               }}
               incluirBuscador
               listaMultiNivelProps={{
                  contraerTodos: true,
                  onItemClick: (e, valor) => handleOnClickItem(e, valor)
               }}
               mapaModulo={{
                  icono: 'icono',
                  nodos: 'hijos',
                  titulo: 'denominacion',
                  valorIgnorar: ''
               }}
               modulos={capacitaciones}
            ></MenuModulos>
         )}
      </>
   );
};

ListaTutorial.propTypes = {
   capacitaciones: PropTypes.array,
   onOpenLista: PropTypes.func,
   arrTutoriales: PropTypes.array,
   onIndex: PropTypes.func
};

ListaTutorial.defaultProps = {
   capacitaciones: [],
   onOpenLista: () => {},
   arrTutoriales: [],
   onIndex: () => {}
};
